import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IServiceConfig } from '../../configurations/store/configurations.types'
import { getServiceConfigSelector } from '../../configurations/selectors/serviceConfig.selector'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPickupAddressOptionsState } from '../../options/store/options.types'
import { getPickupAddressOptionsSelector } from '../../options/selectors/pickupAddressOptions.selector'
import * as pickupAddressActions from '../store/pickupAddress.actions'
import { getPcrIdSelector } from '../../home/selectors'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { PickupAddressConstants } from '../store/pickupAddress.constants'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { initialPickupAddressState } from '../store/pickupAddress.reducers'
import { NemsisCodes } from '../../../common/nemsisCodes.constants'
import { IOption } from '../../../common/common.types'

export function* setRefDefaults(pcrDoc?: IPcr) {
  const serviceConfig: IServiceConfig = yield select(getServiceConfigSelector)
  const { REFTYPE_DEFAULT } = serviceConfig

  const pickupAddressOptions: IPickupAddressOptionsState = yield select(getPickupAddressOptionsSelector)
  const { locationTypeOptions } = pickupAddressOptions
  const refDefaultType = locationTypeOptions.find((option) => option.id === REFTYPE_DEFAULT)
  let otherType
  if (REFTYPE_DEFAULT === 1)
    otherType = { nemsisCodeRef: NemsisCodes.PICKUP_DEFAULT_HOSPITAL_CODE as string } as IOption
  if (REFTYPE_DEFAULT === 2) otherType = { nemsisCodeRef: NemsisCodes.PICKUP_DEFAULT_EMS_CODE as string } as IOption

  if (pcrDoc) {
    pcrDoc.patient = {
      ...pcrDoc.patient,
      pickupAddress: {
        ...initialPickupAddressState,
        typeValue: refDefaultType || null,
        otherType: otherType || null,
        __areDefaultsSet: true,
      },
    }
    return
  }

  if (refDefaultType) yield put(pickupAddressActions.setTypeValue(refDefaultType))
  if (otherType) yield put(pickupAddressActions.setOtherType(otherType))
}

export function* setPickupAddressDefaults() {
  try {
    const pcrID: string = yield select(getPcrIdSelector)
    const serviceId: string = yield select(getServiceIdSelector)
    if (pcrID) {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.patient?.pickupAddress) {
        return
      }

      yield call(setRefDefaults)
    }
  } catch (e) {
    yield put(throwPcrException(`setPickupAddressDefaults() error: ${e}`))
  }
}

export function* setPickupAddressDefaultsSaga() {
  yield takeLatest([PickupAddressConstants.SET_PICKUP_ADDRESS_DEFAULTS], performWithMutexHOG, setPickupAddressDefaults)
}
